import { z } from 'zod';
import { uuid, isoDatetime, dateOnly } from './common.js';

export const paymentReminderScope = z.enum(['owing', 'all']);
export type PaymentReminderScope = z.infer<typeof paymentReminderScope>;

export const paymentRemindersPreviewQuery = z.object({
  scope: paymentReminderScope.default('owing'),
});
export type PaymentRemindersPreviewQuery = z.infer<typeof paymentRemindersPreviewQuery>;

// One unit's reminder row. main_user_* are null when the unit has no Main user
// (primary resident) — such units are shown in the preview but skipped on send.
export const reminderRecipient = z.object({
  unit_id: uuid,
  unit_label: z.string(),
  main_user_id: uuid.nullable(),
  main_user_name: z.string().nullable(),
  outstanding_cents: z.number().int().nonnegative(),
  // 'YYYY-MM-DD' or null when nothing owed
  earliest_due: dateOnly.nullable(),
  invoice_count: z.number().int().nonnegative(),
});
export type ReminderRecipient = z.infer<typeof reminderRecipient>;

export const paymentRemindersPreview = z.object({
  scope: paymentReminderScope,
  units_owing: z.number().int().nonnegative(),
  total_outstanding_cents: z.number().int().nonnegative(),
  last_sent_at: isoDatetime.nullable(),
  recipients: z.array(reminderRecipient),
});
export type PaymentRemindersPreview = z.infer<typeof paymentRemindersPreview>;

export const sendPaymentRemindersRequest = z.object({
  scope: paymentReminderScope,
  message: z.string().trim().min(1).max(500),
});
export type SendPaymentRemindersRequest = z.infer<typeof sendPaymentRemindersRequest>;

export const sendPaymentRemindersResponse = z.object({
  total_recipients: z.number().int().nonnegative(),
  skipped_no_main_user: z.number().int().nonnegative(),
});
export type SendPaymentRemindersResponse = z.infer<typeof sendPaymentRemindersResponse>;
